const marqueeInner = document.querySelector(".marquee_inner");
const marqueePart = Array.from(marqueeInner.children);
for (let i = 0; i < 5; i++) {
    marqueePart.forEach((item) => {
        const duplicatedMarquee = item.cloneNode(true);
        duplicatedMarquee.setAttribute("aria-hidden", true);
        marqueeInner.appendChild(duplicatedMarquee);
    });
}